import {Injectable} from "@angular/core";
import {Appkonfigurasjon} from "./Appkonfigurasjon";
import {HttpsUrl} from "./ressurser/generertNg2HttpKlient";

/** Definerer stier til bilderessurser som serveres over http fra katalogen lederplan-klient/src/bilder.
 * */
@Injectable({providedIn: 'root'})
export class BildeRessurser {

    readonly norskBankidLogo: string;
    readonly norskBankidLogoMedTekst: string;
    readonly svenskBankidLogo: string;

    constructor(private konfigurasjon: Appkonfigurasjon) {
        this.norskBankidLogo = this.sti('logoer/norsk-bankid-lilla.svg');
        this.norskBankidLogoMedTekst = this.sti('logoer/norsk-bankid-lilla__med_tekst.svg');
        this.svenskBankidLogo = this.sti('logoer/svensk-bankid.svg');
    }

    // private hjelpemetoder

    /** returnerer absolutt sti til angitt bilde.
     * Forventer at angitt bilde er en sti relativ til lederplan-klient/src/bilder */
    private sti(bilde: string): HttpsUrl {
        return `${this.konfigurasjon.serviceRotUrl}/app/bilder/${bilde}`;
    }
}
